export default {
    'create-financial-file': 'إنشاء ملف مالي',
    'create-backup': 'إنشاء نسخة احتياطية',
    'edit-financial-file': 'تعديل ملف مالي',
    'backups-management': "إدارة النسخ الاحتياطية",
    'delete-old-backups':"حذف النسخ الاحتياطية القديمة",
    'old-backups-delete-alert': "سيتم حذف جميع النسخ الاحتياطية التي تم إنشاؤها قبل أكثر من 7 أيام",
    'close': "إغلاق",
    "configure-financial-file": "إعداد الملف المالي",
    "financial-file-created-successfully": "لقد قمت بإنشاء ملفك المالي بنجاح",
    "configure-your-financial-file": "هل تريد البدء بإعداد ملفك المالي الآن؟",
    "create-default-warehouse": "إنشاء مستودع افتراضي",
    "default-warehouse": "المستودع الافتراضي",
    "create-accounting-tree": "إنشاء شجرة حسابات",
    "do-you-want-to-create-a-default-accounting-tree": "هل تريد إنشاء شجرة حسابات افتراضية؟(ينصح به)",
    "configure": "إعداد",
    "created-and-configured-successfully": "لقد قمت بإنشاء وإعداد ملفك المالي بنجاح",
    "go-to-settings": "هل تريد تخصيص بعض الإعدادات ل ملفك المالي ؟ انقر للذهاب ل صفحة الإعدادات",
    save: 'حفظ',
    cancel: 'إلغاء',

    confirm: 'مُتابعة',
    'browse-content': 'استعراض محتويات',

    'do-you-want-to-change-the-current-financial-file': 'هل تود تغيير الملف المالي الحالي',

    'rotated-to-$': 'مدور إلى  "{financialFile}"',
    rotated: 'مدور',
    locked: 'مقفل',
    unlocked: 'غير مُقفل',

    'the-users-of-the-file-$-and-their-permissions': 'مُستخدمي ملف {financialFile} وصلاحياتهم',

    permissions: {
        title: 'الصلاحيات',
        'no-permissions': 'لم يتم تحديد صلاحيات',
        viewer: 'مُتصفح بيانات',
        accountant: 'مُحاسب',
        'warehouse-keeper': 'أمين مستودع',
        'warehouse-manager': 'مدير مستودع'
    },

    'the-logo-is-uploaded-successfully': 'تم إرفاق اللوغو بنجاح'
}